import { buildSgPresetPrepareDocumentItem } from '../../presetDocCustSave';
import { classifyAllotmentDoc } from './allotmentDocVariableMap';
import {
  buildAllotmentRows,
  toDirectorsResolutionVariables,
  toMembersResolutionVariables,
  toShareApplicationVariables,
  type IdTypeCodeOption,
} from './useFormPayload';

export interface SelectionDocRow {
  tmpId?: number | null;
  templateName?: string;
  docCode?: string;
}

export function buildAllotmentPresetPrepareDocuments(input: {
  selectionDocuments: SelectionDocRow[];
  formData: Record<string, any>;
  eFilingDataValidation?: Record<string, any> | null;
  directorsSignersJson: string;
  membersSignersJson: string;
  personName: string;
  entityCd?: string;
  applicationDate: string;
  shareholderApprovalDate: string;
  /** B03 options for Share Application applicant_id_label (document title, not BIGO1) */
  idTypeOptions?: IdTypeCodeOption[];
}) {
  const docs = (input.selectionDocuments || []).filter((d) => d.tmpId);
  if (docs.length === 0) return [];

  const rows = buildAllotmentRows({
    formData: input.formData,
    eFilingDataValidation: input.eFilingDataValidation,
  });
  const items: any[] = [];

  for (const d of docs) {
    const kind = classifyAllotmentDoc({
      docCode: d.docCode,
      templateName: d.templateName,
    });
    const templateName = d.templateName || '';
    const templateId = d.tmpId as number | string;

    if (kind === 'share_application') {
      for (const row of rows) {
        const vars = toShareApplicationVariables({
          formData: input.formData,
          row,
          applicationDate: input.applicationDate,
          idTypeOptions: input.idTypeOptions,
        });
        items.push(
          buildSgPresetPrepareDocumentItem({
            templateId,
            templateName,
            personName: row.allotteeName || input.personName,
            commonFormData: vars,
            entityCd: input.entityCd,
          }),
        );
      }
      continue;
    }

    if (kind === 'directors_resolution') {
      items.push(
        buildSgPresetPrepareDocumentItem({
          templateId,
          templateName,
          personName: input.personName,
          commonFormData: toDirectorsResolutionVariables({
            formData: input.formData,
            rows,
            shareholderApprovalDate: input.shareholderApprovalDate,
            directorsSignersJson: input.directorsSignersJson,
          }),
          entityCd: input.entityCd,
        }),
      );
      continue;
    }

    if (kind === 'members_resolution') {
      items.push(
        buildSgPresetPrepareDocumentItem({
          templateId,
          templateName,
          personName: input.personName,
          commonFormData: toMembersResolutionVariables({
            formData: input.formData,
            membersSignersJson: input.membersSignersJson,
          }),
          entityCd: input.entityCd,
        }),
      );
      continue;
    }
  }

  return items;
}

